
export const Constants = {
    LocalStorageKey: {
        TOKEN_KEY: 'token',
        USER_ROLES: 'userRoles',
        USER: 'currentUser',
        AUTO_APPROVED_TRIGGER:'AUTO_APPROVED_TRIGGER',
        AUTO_APPROVED_CURRENCY_EXCHANGE:'AUTO_APPROVED_CURRENCY_EXCHANGE',
        AUTO_APPROVED_CASHIN:'AUTO_APPROVED_CASHIN',
        AUTO_APPROVED_CASHOUT:'AUTO_APPROVED_CASHOUT',
        AVATAR: 'avatar'
    },

    UserRole: {
        ADMIN: 'ADMINISTRATOR',
        USER: 'USER'
    },

    ACL: {
        Admin: 'Admin',
        NormalUser: 'NormalUser'
    },
    STATUS: {
        ACTIVE: "ACTIVE",
        INACTIVE: "INACTIVE",
    },
    CHANNEL: {
        CHANNEL_CODE: 'OPERATOR_DESK'
    },
    BRANCH: {
        BRANCH_CODE: '1112'
    },
    TurnoverPeriods:[
        {value:"CURRENT_MONTH", label: "Current Month"},
        {value:"CURRENT_YEAR", label: "Current Year"},
        {value:"PREVIOUS_MONTH", label: "Previous Month"},
        {value:"PREVIOUS_YEAR", label: "Previous Year"},
        {value:"PREVIOUS_QUARTER", label: "Previous Quarter"}
    ],
    PRODUCT: {
        PRODUCT_ID: '203'
    },
    INTEREST_CALCULATION_OPTIONS: [
        { label: 'loan_template.interest_calc_options.actual_360', value: 'BY_ACTUAL_DAYS_360' },
        { label: 'loan_template.interest_calc_options.actual_365' , value: 'BY_ACTUAL_DAYS_365'}
        // { label: '30/360 — Fixed Month/Year Basis / 360', value: 'BY_FIXED_30_DAYS_360' }
    ],
    INTEREST_CALCULATION_TYPE: [
        { label: 'On The Outstanding Balance', value: 'OUTSTANDING_BALANCE' },
        { label: 'On The Smallest Balance of The Last x Days', value: 'SMALLEST_BALANCE' },
        { label: 'On The Average Balance of The Last x Days', value: 'AVERAGE_BALANCE' },
    ],
    REPAYMENT_TYPE: [
        { label: 'loan_template.repayment_types.daily', value: 'DAILY' },
        { label: 'loan_template.repayment_types.monthly', value: 'MONTHLY' },
        { label: 'loan_template.repayment_types.yearly', value: 'YEARLY' }
    ],
    CALCULATION_TYPE1:[
        { label: 'loan_template.calculate_types1.daily', value: 'DAILY' },
        { label: 'loan_template.calculate_types1.monthly', value: 'MONTHLY' },
    ],
    CALCULATION_TYPE2:[
        { label: 'loan_template.calculate_types2.monthly', value: 'MONTHLY' },
        { label: 'loan_template.calculate_types2.yearly', value: 'YEARLY' }
    ],
    CALCULATION_TYPE3:[
        { label: 'loan_template.calculate_types3.daily', value: 'DAILY' },
    ],
    OPERATION_TYPE: {
        CASH_IN: 'Cash-In',
        CASH_OUT: 'Cash-Out',
        TRANSFER_BETWEEN_CUSTOMER_ACCOUNTS: 'Transfer Between Customer Accounts',
        TRANSFER_TO_OTHER_ACCOUNT: 'Transfer To Other Account',
        SWIFT_TRANSFER: 'Swift Transfer',
        LOAN_REPAYMENT: 'Loan Repayment',
        BANK_TRANSFER: 'Bank Transfer',
        EASY_TRANSFER: 'Easy Transfer',
        DEPOSIT_REPLENISHMENT: 'Deposit Replenishment',
        CURRENCY_EXCHANGE: 'Currency Exchange',
        BUDGET_TRANSFER: 'Budget Transfer',
        UTILITY_PAYMENT: 'Utility Payment',
        LOAN_GRANTING: 'Loan Granting',
        LOAN_SERVICE_FEE_PAYMENT: 'Loan Service Fee Payment',
        DEPOSIT_GRANTING: 'Deposit Granting',
        CASH_IN_ORDER: 'Cash-In Order',
        CASH_OUT_ORDER: 'Cash-Out Order',
        MEMORIAL_ORDER: 'Memorial Order',
    },
    TRANSACTION_BASIS: {
        CASH_IN_ORDER: 'Cash-In Order',
        CASH_OUT_ORDER: 'Cash-Out Order',
        MEMORIAL_ORDER: 'Memorial Order',
        EXCHANGE_ORDER: 'Exchange Order',
        BANK_TRANSFER_ORDER: 'Bank Transfer Order',
    },
    LOAN_TYPE: {
        ACTIVE: 'ACTIVE',
        APPROVED: 'APPROVED',
        DEFERRED: 'DEFERRED',
        DELETED: 'DELETED',
        DRAFT: 'DRAFT',
        CLOSED: 'CLOSED',
        FINISHED: 'FINISHED',
        PRE_OVERDUED: 'PRE_OVERDUED',
        READY_FOR_APPROVAL: 'READY_FOR_APPROVAL',
        REJECTED: 'REJECTED',
        SUSPENDED: 'SUSPENDED',
        WAITING_FOR_APPROVAL: 'WAITING_FOR_APPROVAL'
    },
    SAVING_LINKED_ACCOUNTS:[
        {label:'Interest Account',value: 'INTEREST_ACCOUNT'},
        {label: 'Interest Expense Account',value: 'INTEREST_EXPENSE_ACCOUNT'},
        {label: 'Tax Account',value: 'TAX_ACCOUNT'}
    ],
    COLLATERAL_LINKED_ACCOUNTS:[
        {label:'Collateral Account',value: 'COLLATERAL_ACCOUNT'},
    ],
    GUARANTEE_LINKED_ACCOUNTS:[
        {label:'Guarantee Account',value: 'GUARANTEE_ACCOUNT'},
    ],
    CURRENCY_EXCHANGE_LINKED_ACCOUNTS:[
        {label: 'Income from Currency Exchange Operation',value: 'INCOME_FROM_CURRENCY_EXCHANGE_OPERATION'},
        {label: 'Expense from Currency Exchange Operation',value: 'EXPENSE_ON_CURRENCY_EXCHANGE_OPERATION'},
        {label: 'Income from Account Revaluation Operation',value: 'INCOME_FROM_ACCOUNT_REVALUATION'},
        {label: 'Expense from Account Revaluation Operation',value: 'EXPENSE_FROM_ACCOUNT_REVALUATION'}
    ],
    COMMISSION_LINKED_ACCOUNTS:[
        {label: 'Income from Cash-In Operation',value: 'CASH_IN_OPERATION'},
        {label: 'Income from Cash-Out Operation',value: 'CASH_OUT_OPERATION'},
        // {label: 'Transfer to Other Accounts Operation',value: 'TRANSFER_TO_OTHER_ACCOUNTS'},
        // {label: 'Loan Repayment Operation',value: 'LOAN_REPAYMENT'},
        {label: 'Fee from Bank Transfer Operation',value: 'BANK_TRANSFER_OPERATION'},
        {label: 'Fee from Currency Exchange Operation',value: 'CURRENCY_EXCHANGE_OPERATION'}
    ],
    LOAN_LINKED_ACCOUNTS:[
        {label:'Loan Account',value: 'GRANTING_ACCOUNT'},
        {label:'Interest Account',value: 'INTEREST_ACCOUNT'},
        {label:'Interest Income Account',value: 'INTEREST_INCOME_ACCOUNT'},
        {label:'Service Fee Account',value: 'SERVICE_FEE_ACCOUNT'},
        {label:'Service Fee Income Account',value: 'SERVICE_FEE_INCOME_ACCOUNT'},
        {label:'Late Payment Fee Account',value: 'LATE_REPAYMENT_FEE_ACCOUNT'},
        {label:'Late Payment Fee Income Account',value: 'LATE_REPAYMENT_FEE_INCOME_ACCOUNT'},
        {label:'Interest Late Payment Fee Account',value: 'INTEREST_LATE_REPAYMENT_FEE_ACCOUNT'},
        {label:'Interest Late Payment Fee Income Account',value: 'INTEREST_LATE_REPAYMENT_FEE_INCOME_ACCOUNT'},
        {label:'Service Fee Late Payment Fee Income Account',value: 'SERVICE_FEE_LATE_REPAYMENT_FEE_INCOME_ACCOUNT'},
        {label:'Service Fee Late Payment Fee Account',value: 'SERVICE_FEE_LATE_REPAYMENT_FEE_ACCOUNT'},
        {label:'Early Payment Fee Account',value: 'EARLY_REPAYMENT_FEE_ACCOUNT'},
        {label:'Early Payment Fee Income Account',value: 'EARLY_REPAYMENT_FEE_INCOME_ACCOUNT'},
        {label:'Upfront Fee Income Account',value: 'UPFRONT_FEE_INCOME_ACCOUNT'},
        {label:'Upfront Service Fee Income Account',value: 'SERVICE_UPFRONT_FEE_INCOME_ACCOUNT'},
    ],
    CUSTOMER_TYPES:[
        {label: 'Legal',value: 'LEGAL'},
        {label: 'Individual',value: 'INDIVIDUAL'},
        {label: 'Private Entrepreneur',value: 'PRIVATE_ENTREPRENEUR'},
        {label: 'Financial Company',value: 'FINANCIAL_COMPANY'},
        {label: 'Non Financial Company',value: 'NON_FINANCIAL_COMPANY'},
        {label: 'Other',value: 'OTHER'}
    ],
    COLLATERAL_AGREEMENTS:[
        {label:'Gold Collateral',value: 'GOLD_COLLATERAL'},
        {label:'Real Estate',value: 'REAL_ESTATE'},
        {label:'Vehicles',value: 'VEHICLES'},
        {label:'Goods',value: 'GOODS'},
        {label:'Other Fixed Assets',value: 'OTHER_FIXED_ASSETS'},
        {label:'Bonds',value: 'BONDS'},
        {label:'Other',value: 'OTHER'},
    ],
    JOBS: {
        LOANS: 'Loans',
        SAVINGS: 'Savings',
        COLLATERALS: 'Collaterals',
        GUARANTIES: 'Guaranties',
        LOANS_INTEREST_CALCULATION: 'Interest Calculation',
        LOANS_REPAYMENT: 'Loan Repayment',
        LOANS_CLASSIFICATION: 'Classification Operation',
        LOANS_PROVISIONING: 'Provisioning Operation',
        LOANS_CLOSING: 'Closing',
        SAVINGS_INTEREST_CALCULATION: 'Interest Calculation',
        SAVINGS_INTEREST_PAYMENT: 'Interest Payment',
        SAVINGS_CLOSING: 'Closing',
        COLLATERALS_CLOSING: 'Closing',
        GUARANTIES_CLOSING: 'Closing',
        BANKING_DAY: 'Banking Day',
        SET_BANKING_DAY: 'Set Banking Day',
        BANKING_DAY_CLOSING: 'Banking Day Closing',
        BANKING_DAY_OPENING: 'Banking Day Opening',
        FIRST_WORKING_DAY: 'First Working Day',
        FIRST_CALENDAR_DAY: 'First Calendar Day',
        LAST_WORKING_DAY: 'Last Working Day',
        LAST_CALENDAR_DAY: 'Last Calendar Day',
        DATES: 'Specific Date(s)',
        CURRENT_DATE: 'Current Date',
        CURRENT_DATE_PLUS_1: 'Current Date + 1 day',
        CURRENT_DATE_PLUS_2: 'Current Date + 2 days',
        CURRENT_DATE_PLUS_3: 'Current Date + 3 days',
        DAILY: 'Every Day',
        WEEKLY: 'Days of the Week',
        MONTHLY: 'Monthly',
        1: 'Monday',
        2: 'Tuesday',
        3: 'Wednesday',
        4: 'Thursday',
        5: 'Friday',
        6: 'Saturday',
        7: 'Sunday',
    },
    SAVING_AGREEMENT_STATUS: [
        {active: 'ACTIVE'},
        {ready_for_approval: 'READY_FOR_APPROVAL'},
        {draft: 'DRAFT'},
    ],

    FORMS: {
        LOANS_AGREEMENT: 'Loan Agreement',
        GROUP_LOANS_AGREEMENT: 'Group Loans Agreement',
        LOANS_UPFRONT_FEE_CHARGING: 'Upfront Fee Charging',
        LOANS_GRANTING: 'Loan Granting',
        LOANS_REPAYMENT: 'Loan Repayment',
        SAVINGS_AGREEMENT: 'Saving Agreement',
        SAVINGS_INTEREST_PAYMENT: 'Interest Payment',
        ORDERS_CASH_IN: 'Cash-In Order',
        ORDERS_CASH_OUT: 'Cash-Out Order',
        ORDERS_BANK_TRANSFER: 'Bank Transfer Order',
        ORDERS_MEMORIAL: 'Memorial Order',
        ORDERS_EXCHANGE: 'Currency Exchange Order',
        COLLATERALS_AGREEMENT: 'Collaterals Agreement',
        GUARANTEES_AGREEMENT: 'Guarantees Agreement',
    },
    COMPANY_TYPES: [
        {value: "FINANCIAL_COMPANY", label: "Financial Company"},
        {value: "INDIVIDUAL", label: "Individual"},
        {value: "LEGAL", label: "Legal"},
        {value: "NON_FINANCIAL_COMPANY", label: "Non Financial Company"},
        {value: "PRIVATE_ENTREPRENEUR", label: "Private Entrepreneur"}
    ],
    SAVING_AGREEMENT_TYPES: {
        PERSONAL_SAVING_AGREEMENT: 'Personal Saving Agreement'
    },
    LOAN_TYPES: {
        PERSONAL_LOAN: "Personal Loan"
    },
    TRANSACTION_TYPES: {
        CASH_IN: "Cash-In",
        CASH_OUT: "Cash-Out",
        TRANSFER_BETWEEN_CUSTOMER_ACCOUNTS: "Transfer Between Customer Accounts",
        TRANSFER_TO_OTHER_ACCOUNT: "Transfer To Other Account",
        SWIFT_TRANSFER: "Swift Transfer",
        LOAN_GRANTING: "Lon Granting",
        LOAN_REPAYMENT: "Loan Repayment",
        LOAN_SERVICE_FEE_PAYMENT: "Loan Service Fee Payment",
        BANK_TRANSFER: "Bank Transfer",
        EASY_TRANSFER: "Easy Transfer",
        DEPOSIT_GRANTING: "Deposit Granting",
        DEPOSIT_PREPAYMENT: "Deposit Prepayment",
        DEPOSIT_REPLENISHMENT: "Deposit Replenishment",
        DEPOSIT_SERVICE_FEE_PAYMENT: "Deposit Service Fee Payment",
        CURRENCY_EXCHANGE: "Currency Exchange",
        BUDGET_TRANSFER: "Budget Transfer",
        UTILITY_PAYMENT: "Utility Payment",
        MEMORIAL_ORDER: "Memorial Order",
        CASH_IN_ORDER: "Cash-In Order",
        CASH_OUT_ORDER: "Cash-Out Order",
        UNKNOWN: "Unknown"
    },
    PAGE_ITEM_COUNT: 10,
    REPORT_PAGE_SIZE: 50,
    PAGE_UNLIMITED_ITEM_COUNT: 9999,
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY',
    MONEY_TYPE: {
        CASH: 'CASH',
        NON_CASH: 'NON_CASH'
    },
    NOTIFICATION_TYPES: [
        {value:'ACTIVE', label: 'status.active'},
        {value:'INACTIVE', label: 'status.inactive'}
    ],
    WEEKDAYS : [
        {label: 'weekdays.monday', value: 1},
        {label: 'weekdays.tuesday', value: 2},
        {label: 'weekdays.wednesday', value: 3},
        {label: 'weekdays.thursday', value: 4},
        {label: 'weekdays.friday', value: 5},
        {label: 'weekdays.saturday', value: 6},
        {label: 'weekdays.sunday', value: 7},
    ],
    MONTHLYTYPES : [
        {label: 'monthlyTypes.first_working_day', value: 'FIRST_WORKING_DAY'},
        {label: 'monthlyTypes.first_calendar_day', value: 'FIRST_CALENDAR_DAY'},
        {label: 'monthlyTypes.last_working_day', value: 'LAST_WORKING_DAY'},
        {label: 'monthlyTypes.last_calendar_day', value: 'LAST_CALENDAR_DAY'},
        {label: 'monthlyTypes.dates', value: 'DATES'},
    ],
    SPECIFICDAYS: [
        {label: '1', value: 1}, {label: '2', value: 2}, {label: '3', value: 3}, {label: '4', value: 4},
        {label: '5', value: 5}, {label: '6', value: 6}, {label: '7', value: 7}, {label: '8', value: 8},
        {label: '9', value: 9}, {label: '10', value: 10}, {label: '11', value: 11}, {label: '12', value: 12},
        {label: '13', value: 13}, {label: '14', value: 14}, {label: '15', value: 15}, {label: '16', value: 16},
        {label: '17', value: 17}, {label: '18', value: 18}, {label: '19', value: 19}, {label: '20', value: 20},
        {label: '21', value: 21}, {label: '22', value: 22}, {label: '23', value: 23}, {label: '24', value: 24},
        {label: '25', value: 25}, {label: '26', value: 26}, {label: '27', value: 27}, {label: '28', value: 28},
        {label: '29', value: 29}, {label: '30', value: 30}, {label: '31', value: 31},
    ],
    TIMECYCLES : [
        {label: 'jobCycles.daily', value: 'DAILY'},
        {label: 'jobCycles.weekly', value: 'WEEKLY'},
        {label: 'jobCycles.monthly', value: 'MONTHLY'},
    ],
    CHANNELS : [
        {label: 'notifications.sms', value: 'SMS'},
        {label: 'notifications.mail', value: 'EMAIL'},
        {label: 'notifications.push', value: 'PUSH_NOTIFICATION'}
    ],
    PUSHNOTIFICATION_GROUPS: [
        {label: 'push-notification-groups.loan', value: 'Loan'},
        {label: 'push-notification-groups.saving', value: 'Saving'},
        {label: 'push-notification-groups.collateral', value: 'Collateral'},
        {label: 'push-notification-groups.guarantee', value: 'Guarantee'},
    ]


}
